import { render, staticRenderFns } from "./TagForm.vue?vue&type=template&id=1e0e10b1&scoped=true"
import script from "./TagForm.vue?vue&type=script&lang=js"
export * from "./TagForm.vue?vue&type=script&lang=js"
import style0 from "./TagForm.vue?vue&type=style&index=0&id=1e0e10b1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e0e10b1",
  null
  
)

export default component.exports